<template>
    <v-dialog v-model="displayAllApenafs" width="800">
        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                Tous les codes NAF concernés
            </v-card-title>
            <v-simple-table fixed-header height="500px" class="table-container">
                <thead>
                    <tr>
                        <th class="text-center" width="150px">
                            <typo> Code </typo>
                        </th>
                        <th class="text-center">
                            <typo> Activité </typo>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="apenaf in apenafsInConvention" :key="apenaf._uid">
                        <td>
                            <typo name="body-14-light">
                                {{ apenaf.code }}
                            </typo>
                        </td>
                        <td>
                            <typo
                                v-if="!apenaf.hideDefaultTitle && apenaf.code"
                                name="body-14-light"
                            >
                                {{ getApenafLabel(apenaf.code) }}
                            </typo>
                            <br />
                            <typo
                                name="body-14-light"
                                v-if="apenaf.description"
                                v-html="apenaf.description"
                            />
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <v-card-actions>
                <v-spacer></v-spacer>
                <action class="apply-button" @click="close" name="main" :nochevron="true">
                    Fermer
                </action>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import { get } from "lodash";

export default {
    components: {},
    props: ["apenafsByCode", "apenafsInConvention", "variantId"],
    data() {
        return {
            displayAllApenafs: false,
        };
    },
    mounted() {
        EventBus.$on(`displayAllApenafs-${this.variantId}`, displayAllApenafs => {
            this.displayAllApenafs = displayAllApenafs;
        });
    },
    methods: {
        close() {
            EventBus.$emit(`displayAllApenafs-${this.variantId}`, false);
        },
        getApenafLabel(code) {
            return get(this.apenafsByCode, `${code}.label`, "");
        },
    },
};
</script>

<style scoped lang="sass">
.table-container
    margin: 10px 24px
    overflow-y: auto
</style>
